/**
 * Hearts in words (review 0025): the game card, the pass, the seats, the toasts and why a card
 * was refused. Apart, so each language file stays in budget.
 */
export const heartsEn = {
  "variant.hearts": "Hearts",
  "variant.hearts.blurb":
    "Solo, no trump: dodge the hearts and the queen of spades. At 100 the lowest score wins.",
  "rule.hearts.jackOfDiamonds": "Jack of diamonds",
  "rule.hearts.jackOfDiamonds.true": "Takes 10 off",
  "rule.hearts.jackOfDiamonds.false": "Just a card",
  "hearts.pass.title": "Pass three cards",
  "hearts.pass.left": "To the player on your left: {name}",
  "hearts.pass.right": "To the player on your right: {name}",
  "hearts.pass.across": "To the player across: {name}",
  "hearts.pass.count": "{count} of 3 chosen",
  "hearts.pass.need": "Choose 3 cards to pass; {count} chosen.",
  "hearts.pass.send": "Pass",
  "hearts.seat.choose": "Choose 3 cards",
  "hearts.seat.choosing": "Choosing…",
  "hearts.seat.passed": "Passed",
  "hearts.seat.points": "{points} pts this hand",
  "hearts.bar.open": "Hearts open",
  "hearts.bar.closed": "Hearts closed",
  "hearts.event.passed.left": "Cards passed to the left",
  "hearts.event.passed.right": "Cards passed to the right",
  "hearts.event.passed.across": "Cards passed across",
  "hearts.event.received": "{name} gave you {cards}",
  "hearts.event.hold": "Hand {hand}: no passing this hand",
  "hearts.event.broken": "Hearts are broken",
  "hearts.event.queen": "{name} took the queen of spades",
  "hearts.handEnd.moon": "{name} shot the moon!",
  "hearts.handEnd.moon.sub": "Everyone else takes 26",
  "hearts.handEnd.title": "Hand {hand}: you took {points}",
  "hearts.handEnd.watch": "Hand {hand} is scored",
  "error.hearts-not-broken": "Hearts are not broken yet.",
  "error.lead-two-of-clubs": "The two of clubs opens the hand.",
  "error.first-trick-points": "No hearts or queen of spades on the first trick.",
  "error.invalid-pass": "Choose three of your own cards.",
  "error.already-passed": "You have already passed your cards.",
};

type HeartsKey = keyof typeof heartsEn;

export const heartsTr: Record<HeartsKey, string> = {
  "variant.hearts": "Hearts",
  "variant.hearts.blurb":
    "Maça Kızı: tekli, koz yok. Kupalardan ve maça kızından kaç; 100'de en düşük puan kazanır.",
  "rule.hearts.jackOfDiamonds": "Karo valesi",
  "rule.hearts.jackOfDiamonds.true": "10 puan siler",
  "rule.hearts.jackOfDiamonds.false": "Sıradan kart",
  "hearts.pass.title": "Üç kart geçir",
  "hearts.pass.left": "Solundaki oyuncuya: {name}",
  "hearts.pass.right": "Sağındaki oyuncuya: {name}",
  "hearts.pass.across": "Karşındaki oyuncuya: {name}",
  "hearts.pass.count": "3 karttan {count} seçildi",
  "hearts.pass.need": "Geçirmek için 3 kart seç; {count} seçili.",
  "hearts.pass.send": "Geçir",
  "hearts.seat.choose": "3 kart seç",
  "hearts.seat.choosing": "Seçiyor…",
  "hearts.seat.passed": "Geçirdi",
  "hearts.seat.points": "Bu el {points} puan",
  "hearts.bar.open": "Kupa açık",
  "hearts.bar.closed": "Kupa kapalı",
  "hearts.event.passed.left": "Kartlar sola geçti",
  "hearts.event.passed.right": "Kartlar sağa geçti",
  "hearts.event.passed.across": "Kartlar karşıya geçti",
  "hearts.event.received": "{name} sana verdi: {cards}",
  "hearts.event.hold": "{hand}. el: bu el kart geçirilmez",
  "hearts.event.broken": "Kupa kırıldı",
  "hearts.event.queen": "Maça kızını {name} aldı",
  "hearts.handEnd.moon": "{name} ayı vurdu!",
  "hearts.handEnd.moon.sub": "Diğer herkes 26 puan alır",
  "hearts.handEnd.title": "{hand}. el: {points} puan aldın",
  "hearts.handEnd.watch": "{hand}. el puanlandı",
  "error.hearts-not-broken": "Kupa henüz kırılmadı.",
  "error.lead-two-of-clubs": "Eli sinek ikili açar.",
  "error.first-trick-points": "İlk ele kupa ya da maça kızı atılmaz.",
  "error.invalid-pass": "Kendi elinden üç kart seç.",
  "error.already-passed": "Kartlarını zaten geçirdin.",
};

/** Draft, like the rest of the Arabic dictionary: waits for a native check (review 0021). */
export const heartsAr: Record<HeartsKey, string> = {
  "variant.hearts": "هارتس",
  "variant.hearts.blurb":
    "فردي وبلا حكم: تجنّب أوراق القلوب وبنت البستوني. عند 100 يفوز صاحب أقل نقاط.",
  "rule.hearts.jackOfDiamonds": "ولد الديناري",
  "rule.hearts.jackOfDiamonds.true": "يخصم 10 نقاط",
  "rule.hearts.jackOfDiamonds.false": "ورقة عادية",
  "hearts.pass.title": "مرّر ثلاث أوراق",
  "hearts.pass.left": "إلى اللاعب على يسارك: {name}",
  "hearts.pass.right": "إلى اللاعب على يمينك: {name}",
  "hearts.pass.across": "إلى اللاعب المقابل: {name}",
  "hearts.pass.count": "تم اختيار {count} من 3",
  "hearts.pass.need": "اختر 3 أوراق للتمرير؛ المختار {count}.",
  "hearts.pass.send": "مرّر",
  "hearts.seat.choose": "اختر 3 أوراق",
  "hearts.seat.choosing": "يختار…",
  "hearts.seat.passed": "مرّر",
  "hearts.seat.points": "{points} نقطة في هذه الجولة",
  "hearts.bar.open": "القلوب مفتوحة",
  "hearts.bar.closed": "القلوب مغلقة",
  "hearts.event.passed.left": "مُرّرت الأوراق إلى اليسار",
  "hearts.event.passed.right": "مُرّرت الأوراق إلى اليمين",
  "hearts.event.passed.across": "مُرّرت الأوراق إلى المقابل",
  "hearts.event.received": "{name} أعطاك {cards}",
  "hearts.event.hold": "الجولة {hand}: لا تمرير في هذه الجولة",
  "hearts.event.broken": "كُسرت القلوب",
  "hearts.event.queen": "{name} أخذ بنت البستوني",
  "hearts.handEnd.moon": "{name} جمع كل النقاط!",
  "hearts.handEnd.moon.sub": "يأخذ الباقون 26 نقطة",
  "hearts.handEnd.title": "الجولة {hand}: أخذت {points}",
  "hearts.handEnd.watch": "تم احتساب الجولة {hand}",
  "error.hearts-not-broken": "لم تُكسر القلوب بعد.",
  "error.lead-two-of-clubs": "تبدأ الجولة بورقة 2 سباتي.",
  "error.first-trick-points": "لا قلوب ولا بنت البستوني في اللمّة الأولى.",
  "error.invalid-pass": "اختر ثلاث أوراق من يدك.",
  "error.already-passed": "لقد مرّرت أوراقك بالفعل.",
};
